import React, { useEffect } from "react";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import BrandMarquee from "@/components/BrandMarquee";
import Catalog from "@/components/Catalog";
import Manifesto from "@/components/Manifesto";
import Testimonials from "@/components/Testimonials";
import Footer from "@/components/Footer";
import CartSheet from "@/components/CartSheet";

function App() {
  useEffect(() => {
    document.title = "Winselindo — Toko Gadget Premium";
  }, []);

  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <CartProvider>
        <div className="grain" />
        <div className="bg-[#050505] min-h-screen antialiased">
          <Navbar />
          <main>
            <Hero />
            <BrandMarquee />
            <Catalog />
            <Manifesto />
            <Testimonials />
          </main>
          <Footer />
          <CartSheet />
        </div>
        <Toaster position="bottom-right" theme="dark" richColors />
      </CartProvider>
    </ReactLenis>
  );
}

export default App;
